import React from 'react';
import { Button, Typography, Box, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
const theme = useTheme();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(to bottom right, #f5f5f5, #e0e0e0)',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Box sx={{ position: 'absolute', inset: 0, backgroundSize: '20px 20px', opacity: 0.05 }} />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          maxWidth: '600px',
          width: '100%',
          padding: '2rem',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)',
          textAlign: 'center',
          position: 'relative',
          zIndex: 10,
        }}
      >
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          style={{ height: '100px', width: '100px', color: '#999', margin: 'auto' }}
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 2, ease: 'easeInOut' }}
        >
          <motion.path
            fill="none"
            stroke="currentColor"
            strokeWidth="0.5"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
          />
        </motion.svg>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          <Typography variant="h1" fontWeight="bold" color={theme.palette.secondary.main} gutterBottom>
            404
          </Typography>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.5 }}
        >
          <Typography variant="h5" color="textSecondary" gutterBottom>
            Oops! This page seems to have wandered off.
          </Typography>
        </motion.div>
        <Box mt={4} display="flex" flexDirection="column" gap={2}>
          <Button
            onClick={() => navigate('/')}
            variant="contained"
            color="primary"
            sx={{ width: '100%', py: 1.5, }}
          >
            Return to homepage
          </Button>
          <Button
            onClick={() => navigate(-1)}
            variant="outlined"
            color="primary"
            sx={{ width: '100%', py: 1.5,
                ":hover":{
                    backgroundColor: theme.palette.secondary.main,
                    color:"#fff"
                }
              }}
          >
            Go back to previous page
          </Button>
        </Box>
      </motion.div>
    </Box>
  );
}
